import React, { useEffect, useState, useCallback } from "react";
import API from "../Services/ButtonColor";

const ButtonColor = ({ selectedButtonColor, setSelectedButtonColor, buttonColors }) => {

    const [buttonColor, setButtonColor] = useState([]);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setSelectedButtonColor(e.target.value);
        
    };

    const bindButtonColor = async () => {
        try {

            const response = await API.bindButtonColor({
                is_active: 1,
                limit: 0
            });
            setButtonColor(response?.data?.data?.rows);
            //console.log('button',response?.data?.data);
        } catch (error) {
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            setError("Failed to fetch Button Color.");
            console.error(error);
        }
    };
    useEffect(() => {
        bindButtonColor();
    }, []);

    return (
        <div className="row">
            <div className="col-md-12">
                {/* <div className="form-group"> */}
                    <label htmlFor="Designation" className="mb-1">Select Button Color <span style={{ color: "red" }}>*</span></label>
                    <select className="form-select" id="ddlcolor" value={selectedButtonColor}
                        onChange={handleChange}>
                        <option value="">Select</option>
                        {buttonColor.length > 0 ? (
                            buttonColor.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))
                        ) : (
                            <option disabled>No Button Color available</option>
                        )}
                    </select>
                    {/* {error && <p style={{ color: 'red' }}>{error}</p>} */}
                {/* </div> */}
            </div>
        </div>
    );
};

export default ButtonColor;
